import { Component, inject } from '@angular/core'
import { RouterLink } from '@angular/router'

import { Confirmable } from '@app/modules/ui/models/confirmable'
import { ModalService } from '@app/overlays/modal/modal.service'

import { ButtonComponent } from '../../../modules/ui/components/button/button.component'
import { MemberService } from '../../../services/member.service'
import { ModalWhyVerifyComponent } from '../why-verify/why-verify.component'

@Component({
  selector: 'sb-modal-limited',
  templateUrl: './limited.component.html',
  styleUrl: '../../../overlays/modal/modal-content.scss',
  imports: [ButtonComponent, RouterLink],
})
export class ModalLimitedComponent extends Confirmable {
  readonly memberService = inject(MemberService)
  private readonly modalService = inject(ModalService)

  openWhyVerify(): void {
    const { instance } = this.modalService.create(ModalWhyVerifyComponent)
    instance.onConfirm(() => this.confirm())
  }
}
